import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../context/AuthContext";
import { useNavigate, Link, Navigate, useSearchParams } from "react-router-dom";
import axiosInstance from "../api/axios";

function Signup() {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState(null);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const inviteCode = searchParams.get("code");

  const [token, setToken] = useState("");

  useEffect(() => {
    setToken(inviteCode ?? "");
  }, [inviteCode]);

  if (user) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (e) => {
    setError(null);
    e.preventDefault();
    try {
      axiosInstance
        .post(
          "/auth/registration/",
          {
            username: username,
            email: email,
            first_name: firstname,
            last_name: lastname,
            phone_number: phoneNumber,
            password1: password1,
            password2: password2,
            signup_code: token,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          alert("Registration Successful!");
          navigate("/");
        })
        .catch((error) => {
          const msg =
            error.response?.data?.detail ??
            (error.response?.data && JSON.stringify(error.response.data)) ??
            error.message;
          setError(String(msg));
          if (error.response) {
            console.error("❌ Registration error:", error.response.data);
            console.error(error.response.data.password1);
          } else {
            console.error("❌ Something went wrong:", error.message);
          }
          // navigate("/signup");
        });
    } catch (err) {
      alert("Signup failed");
    }
    // navigate("/");
  };

  return (
    <div className="flex flex-col lg:flex-row w-screen">
      <div className="flex items-center justify-center border-blue-500 lg:h-screen lg:border-r lg:w-3/5">
        <div className="flex items-center justify-center lg:h-screen">
          <img
            src={`${process.env.PUBLIC_URL}/blorp_logo.png`}
            alt="[blorp Art]"
            className="w-48 h-48 object-contain sm:w-72 sm:h-72"
          />
        </div>
      </div>
      <div className="flex flex-col max-w-md my-auto mx-auto lg:w-2/5">
        {error && <div className="mb-3 rounded bg-red-50 p-3 text-red-700">{error}</div>}
        <form onSubmit={handleSubmit} className="p-4 max-w-md mx-auto">
          <h1 className="text-xl font-bold mb-4">Sign Up</h1>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full mb-2 p-2 border rounded"
          />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            placeholder="First Name"
            value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
            className="w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            placeholder="Last Name"
            value={lastname}
            onChange={(e) => setLastname(e.target.value)}
            className="w-full mb-2 p-2 border rounded"
          />
          <input
            type="tel"
            name="phone_number"
            placeholder="Phone Number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            className="w-full mb-2 p-2 border rounded"
          />
          <input
            type="password"
            placeholder="Password"
            value={password1}
            onChange={(e) => setPassword1(e.target.value)}
            className="w-full mb-2 p-2 border rounded"
          />
          <input
            type="password"
            placeholder="Confirm Password"
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            className="w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            placeholder="SIGNUP CODE"
            value={inviteCode}
            onChange={(e) => setToken(e.target.value)}
            className="w-full mb-2 p-2 border rounded"
          />
          <button className="bg-blue-500 text-white w-full px-4 py-2 mb-2 rounded hover:bg-black hover:text-white">
            Sign Up
          </button>
          <Link to="/login">
            <button className="border border-black w-full px-4 py-2 rounded hover:bg-black hover:text-white">
              Log In
            </button>
          </Link>
        </form>
      </div>
    </div>
  );
}

export default Signup;
